import { render } from "./Solicitacoes.vue?vue&type=template&id=120d4e62&scoped=true"
import script from "./Solicitacoes.vue?vue&type=script&lang=js"
export * from "./Solicitacoes.vue?vue&type=script&lang=js"

import "./Solicitacoes.vue?vue&type=style&index=0&id=120d4e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120d4e62"]])

export default __exports__